import store from '@/store/store'

class RouteState {
  static use(router) {
    router.beforeEach(async (to, from, next) => {
      const tabId = to?.params?.tabId
      // const tabId = to?.params?.type
      await store.dispatch('schedules/setCurrentTabId', tabId)

      next()
    })
  }
}

export default RouteState
